import React, { Component } from "react";
import CIR from "../../../components/CIR/CIR";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CardForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente Card
================================================================================ */
class CIRForm extends Component{
    render(){
        return(
            <CIR/>  
        )   
    }
}

export default CIRForm;